<script type="text/ecmascript-6">
import Question from "./mixin/Question.vue";

export default {
    mixins: [
        Question
    ],
    props: {
        title: {
            default(){
                return 'Panel Category';
            }
        },
        component_id: {
            default(){
                return 'panel_category';
            }
        },
        securedByDesign: {
            required: false,
            default: 0,
        },
        doorCore: {
            required: false,
            default: 0,
        },
        doorRange: {
            required: false,
            default: 0,
        },
    },
    computed: {
        thumbURL(){
            return '/thumb/category/';
        },
        url(){
            return '/api/options/' + this.fabricator + '/panel-category?secured_by_design=' + this.securedByDesign + '&door_core=' + this.doorCore + '&door_range=' + this.doorRange;
        },
        cache_key(){
            return '_' + this.securedByDesign + '_' + this.doorCore + '_' + this.doorRange;
        },
    },
    watch: {
        'cache_key': function (val, oldVal) {
            this.update_options();
        },
    }
}
</script>
